import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { fg } from '../copyFeatGrowth'
import { useFlag, useQa } from '../lib/flags'
import { currentWindow, rangeLabel } from '../lib/weekend'
import { ChevronRight } from '../ui/icons'

/**
 * The door to "This weekend, for you" (features 10/16), one line on Browse: Thursday to Sunday only (LA time, or the
 * QA panel's "pretend today is"), behind the weekend flag. Browse.tsx mounts it with one line.
 */
export function WeekendEntry({ className = '' }: { className?: string }) {
  const on = useFlag('weekend')
  const qa = useQa()
  const w = useMemo(() => currentWindow(), [qa.now]) // eslint-disable-line react-hooks/exhaustive-deps
  if (!on || !w.open) return null
  return (
    <Link to="/weekend" data-review-id="weekend-entry"
      className={`gh-card press group flex items-center justify-between gap-4 border border-line bg-surface p-5 hover:bg-sunk ${className}`}>
      <span className="min-w-0">
        <span className="t-headline block text-ink">{fg('fg.wk_entry_title')}</span>
        <span className="t-body mt-1 block text-ink-2">{fg('fg.wk_entry_body', { range: rangeLabel(w.from, w.to) })}</span>
        <span className="t-control mt-2 block text-accent-ink underline-offset-4 group-hover:underline">{fg('fg.wk_entry_cta')}</span>
      </span>
      <ChevronRight size={20} className="shrink-0 text-ink-2" />
    </Link>
  )
}
